module.exports = __webpack_public_path__ + "img/CS24S室内摄像机.d56ac863.jpg";